<template>
  <div class="col col-lg-2">
    <div class="input-group">
      <label for="segmentoEmpresaField">
        Segmento
        <span class="recent-updated-label" v-if="recentUpdatedField && !isDisabled">
          <tooltip-informacao-alterada />
        </span>
        <select
          :disabled="isDisabled"
          id="segmentoEmpresaField"
          v-model.trim="model.content"
          class="form-select"
          :class="{
            'is-invalid-yellow': $v.model.content.$error && invalidYellow,
            'recent-updated': recentUpdatedField && !isDisabled,
          }"
        >
          <option
            v-for="(segmento, segmentoIndex) in list"
            :key="`segmento_empresa_${segmentoIndex}`"
            :value="segmento"
          >
            {{ segmento.nome }}
          </option>
        </select>
        <div class="form-text text-segmento">Escolha na lista.</div>
      </label>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import EmpresaService from "@/services/portal/empresa/EmpresaService";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
import FieldTemplateUpperCase from "@/components/forms/fields/empresa/FieldTemplateUpperCase.vue";
export default {
  extends: FieldTemplateUpperCase,
  props: {
    modelProp: Object,
    invalidYellow: Boolean,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      loadList: undefined,
      list: new Array(),
      model: {
        name: "segmento",
        content: "",
      },
    };
  },
  computed: {
    isDisabled() {
      if (!this.$parent.model.tipo) return false;
      if (
        this.$parent.model.tipo.restrictions.fields.includes(this.model.name)
      ) {
        this.model.content = null;
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.loadList = EmpresaService.listSegmento()
      .then(
        ({ data }) => (this.list = data.filter((segmento) => segmento.ativo))
      )
      .catch((error) => console.log(error));
  },
  watch: {
    invalidYellow: {
      deep: true,
      handler() {
        if (this.invalidYellow) {
          this.$v.$touch();
        } else {
          this.$v.$reset();
        }
      },
    },
  },
  validations: {
    model: {
      content: {
        required: requiredIf(function () {
          if (this.invalidYellow) {
            return true;
          }
          return false;
        }),
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}
.text-segmento {
  width: 230px;
}
</style>
